module.exports = __webpack_public_path__ + "json/buildings-7.json?4027b36fe9ba154fc2ab2c183bfe4c34";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/buildings/buildings-7.json
// module id = 1726
// module chunks = 3